export default __webpack_public_path__ + "static/media/5.62b1d119.JPG";